module.exports = __webpack_public_path__ + "img/cover.62218da7.jpg";